// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatList_container__1PUhM"};